"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _text = require("@mmc/text");
var _vlpTableCarousel = _interopRequireDefault(require("../vlp-table-carousel.css"));
var MileageCard = function MileageCard(_ref) {
  var firstBoxLabel = _ref.firstBoxLabel,
    firstBoxValue = _ref.firstBoxValue,
    firstBoxDisclaimerLabel = _ref.firstBoxDisclaimerLabel,
    secondBoxLabel = _ref.secondBoxLabel,
    secondBoxValue = _ref.secondBoxValue,
    secondBoxDisclaimerLabel = _ref.secondBoxDisclaimerLabel,
    thirdBoxLabel = _ref.thirdBoxLabel,
    thirdBoxValue = _ref.thirdBoxValue,
    thirdBoxDisclaimerLabel = _ref.thirdBoxDisclaimerLabel,
    description = _ref.description,
    title = _ref.title,
    disclaimerData = _ref.disclaimerData;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _vlpTableCarousel["default"].card
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _vlpTableCarousel["default"].mileageCard
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _vlpTableCarousel["default"].city
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: _vlpTableCarousel["default"].value
  }, firstBoxValue), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: firstBoxLabel,
    className: _vlpTableCarousel["default"].name,
    tag: "p",
    disclaimerData: disclaimerData
  }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: firstBoxDisclaimerLabel,
    className: _vlpTableCarousel["default"].disclaimer,
    tag: "p",
    disclaimerData: disclaimerData
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _vlpTableCarousel["default"].highway
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: _vlpTableCarousel["default"].value
  }, secondBoxValue), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: secondBoxLabel,
    className: _vlpTableCarousel["default"].name,
    tag: "p",
    disclaimerData: disclaimerData
  }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: secondBoxDisclaimerLabel,
    className: _vlpTableCarousel["default"].disclaimer,
    tag: "p",
    disclaimerData: disclaimerData
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _vlpTableCarousel["default"].combined
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: _vlpTableCarousel["default"].value
  }, thirdBoxValue), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: thirdBoxLabel,
    className: _vlpTableCarousel["default"].name,
    tag: "p",
    disclaimerData: disclaimerData
  }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: thirdBoxDisclaimerLabel,
    className: _vlpTableCarousel["default"].disclaimer,
    tag: "p",
    disclaimerData: disclaimerData
  }))), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: title,
    className: _vlpTableCarousel["default"].cardTitle,
    tag: "p",
    disclaimerData: disclaimerData
  }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: description,
    className: _vlpTableCarousel["default"].cardDescription,
    tag: "p",
    disclaimerData: disclaimerData
  }));
};
var _default = MileageCard;
exports["default"] = _default;